/*
 * Copyright © 2022 EPO: European Patent Office.
 * ALL RIGHTS RESERVED
 */
export const notificationType = Object.freeze({
  JOIN_ORGANIZATION: 'JOIN_ORGANIZATION',
  MERGE_USER_ACCOUNT: 'MERGE_USER_ACCOUNT',
});
